import { ISOCode } from 'src/components/molecules/WorldMap/worldMap.types';

export interface FiltersStoreType extends FiltersStoreCountType {
  size: number;
  page: number;
  sort: string;
}

export interface FiltersStoreCountType {
  searchTerm: string;
  region: string[];
  country: ISOCode[];
  sector: string[];
  sector2: string[];
  typeOfProjectPartner: string[];
  ratingMin: number;
  ratingMax: number;
}

export enum FiltersStoreKind {
  INITIAL = 'INITIAL',
  UPDATE_RATING = 'UPDATE_RATING',
  UPDATE_DROPDOWN = 'UPDATE_DROPDOWN',
  UPDATE_SIZE = 'UPDATE_SIZE',
  UPDATE_PAGE = 'UPDATE_PAGE',
  UPDATE_SEARCH_TERM = 'UPDATE_SEARCH_TERM',
  UPDATE_SORTING = 'UPDATE_SORTING',
}

export type FiltersStoreAction =
  | {
      type: FiltersStoreKind.UPDATE_RATING;
      payload: { ratingMin: number; ratingMax: number };
    }
  | {
      type: FiltersStoreKind.INITIAL;
      payload: FiltersStoreType;
    }
  | {
      type: FiltersStoreKind.UPDATE_DROPDOWN;
      payload: {
        key: string;
        value: string[];
      };
    }
  | {
      type: FiltersStoreKind.UPDATE_SIZE;
      payload: number;
    }
  | {
      type: FiltersStoreKind.UPDATE_PAGE;
      payload: number;
    }
  | {
      type: FiltersStoreKind.UPDATE_SEARCH_TERM;
      payload: string;
    }
  | {
      type: FiltersStoreKind.UPDATE_SORTING;
      payload: string;
    };
